import React from 'react';

import Pagination from 'components/Pagination';

const FacilityPagination = ({ options, onPageChange, loading }) => {
  return (
    <div className="mt-8">
      <Pagination
        currentPage={options.page}
        totalPages={Math.ceil(options.total / options.page_size) ?? 0}
        onPageChange={onPageChange}
        loading={loading}
      />
    </div>
  );
};

export default React.memo(FacilityPagination);
